import { Outlet } from 'react-router-dom'
import useCurrentPath from '../../../../hooks/useCurrentPath'
import GroupList from './GroupList/GroupList'

const ManageGroup = () => {
  
  const { currentPath } = useCurrentPath()

  return (
    <>
      <Outlet />
      <GroupList target={currentPath} />
    </>
  )
}

export default ManageGroup
